export const MULTI_REGION_HEADER_LIMIT = 1;
